import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { UserProfileDto, UserType } from '@buck-e-icp/interfaces';

export const routingConfig = {
    unauthorizedRedirect: ['/unauthorized'],
    authorizedRedirects: [
        {
            path: ['/admin'],
            userTypes: [UserType.ADMIN],
        },
        {
            path: ['/management/dashboard'],
            userTypes: [UserType.SCHOOL, UserType.CITY],
        },
        {
            path: ['/parent'],
            userTypes: [UserType.PARENT],
        },
    ],
};

@Injectable({ providedIn: 'root' })
export class DefaultRouteService {
    private router = inject(Router);

    getDefaultRouteTree(activeUserProfile: UserProfileDto | null): UrlTree {
        if (!activeUserProfile) return this.router.createUrlTree([routingConfig.unauthorizedRedirect]);
        const authorizedRedirects = routingConfig.authorizedRedirects;
        const redirect = authorizedRedirects.find((redirect) => {
            const matchingUserTypeRedirect = redirect.userTypes.findIndex(
                (userType) => userType === activeUserProfile.type,
            );
            return matchingUserTypeRedirect !== -1;
        });
        return redirect?.path
            ? this.router.createUrlTree(redirect.path)
            : this.router.createUrlTree([routingConfig.unauthorizedRedirect]);
    }
}
